import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { User } from '@/types';
import { OnboardingStorage } from '@/utils/onboarding.utils';

interface OnboardingGuardProps {
  user: User;
  children: React.ReactNode;
}

const OnboardingGuard: React.FC<OnboardingGuardProps> = ({ user, children }) => {
  const location = useLocation();
  
  const needsOnboarding = OnboardingStorage.needsOnboarding(user);
  
  if (needsOnboarding && location.pathname !== '/') {
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
};

export default OnboardingGuard;